const TenderClosed = () => (
    <h1 className="text-info">Kilpailutus on päättynyt</h1>
  )
  
  export default TenderClosed
  